import { createRouter, createWebHistory } from "vue-router";
import type {
  Router,
  RouteComponent,
  RouteRecordRaw,
  RouteLocationNormalized,
  RouteLocationNormalizedLoaded
} from "vue-router";
import { routerGuard } from "@/router/routerGuard";

export type RouteMeta = {
  myProperty?: string;
};

export type RouteRecordRawCustom = RouteRecordRaw & {
  meta?: RouteMeta;
};

export const getRoutes = (): RouteRecordRawCustom[] => {
  return [
    {
      path: "/",
      name: "SpotTierMainPage",
      component: (): Promise<RouteComponent> => import("@/views/SpotTierMainPageView.vue"),
      props: true
    },
    {
      path: "/oauth",
      name: "OAuthCallback",
      component: { template: "<div />" }
    },
    {
      path: "/spot-exclusion",
      name: "SpotExclusion",
      component: (): Promise<RouteComponent> => import("@/views/SpotExclusionView.vue"),
      props: true
    },
    { path: "/:pathMatch(.*)*", redirect: "/" }
  ];
};

export const scrollBehavior = (
  _to: RouteLocationNormalized,
  _from: RouteLocationNormalizedLoaded,
  savedPosition: any | null
) => {
  if (savedPosition) {
    return savedPosition;
  } else {
    return { left: 0, top: 0, behaviour: "smooth" };
  }
};

let router: Router;

export const getRouter = (): Router => {
  if (!router) {
    router = createRouter({
      history: createWebHistory("/"),
      // See https://router.vuejs.org/guide/advanced/scroll-behavior.html
      // Provides smooth scrolling back-to-top behavior on page transition
      scrollBehavior,
      routes: getRoutes()
    });

    router.beforeEach(routerGuard);
  }

  return router;
};
